import { Component } from '@angular/core';

@Component({
    selector: 'service',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class ServiceComponent {}
